import React, { useState, useEffect } from 'react';
import {
    Portlet,
    PortletBody,
    PortletHeader
} from "../../../partials/content/Portlet";
import { store } from 'react-notifications-component';
import { Container, Row, Col, Card, Form, Button, Modal } from 'react-bootstrap';
import FilterComponent from '../../../partials/layout/FilterComponent';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { withRouter } from 'react-router-dom';
import * as constants from '../../../constants';
import { formatDateTime, formatAmount } from '../../../../_metronic/utils/utils';
// import UltimatePagination from '../../../partials/layout/PaginationComponent';
import { RefundPaymentsServices } from './RefundPayments.service';
const RefundTokenPayments = (props) => {
    const [isFetching, setIsFetching] = useState(false);
    const [paymentData, setPaymentData] = useState(null);
    // const [page, setPage] = useState(1);
    // const [total, setTotal] = useState(undefined);
    // const [offset, setOffset] = useState(0);
    // const [limit, setLimit] = useState(10);
    const [showInitiateRefundModal, setShowInitiateRefundModal] = useState(false);
    const [showRefundDetailsModal, setShowRefundDetailsModal] = useState(false);
    const [tokenPayments, setTokenPayments] = useState(null);
    const [selectedRefund, setSelectedRefund] = useState(null);
    const [filters, setFilters] = useState({
        minimumDatetime: new Date(new Date().setDate(new Date().getDate() - 15)).toISOString().split("T")[0],
        maximumDatetime: new Date().toISOString().split("T")[0],
        transactionType: 0,
        listingId: undefined
    });
    const [allowedUserEmails] = useState([
        "prem.gupta@azuro.in",
        "gauri.morey@azuro.in",
        "support@azuro.in"
    ]);

    useEffect(() => {
        const fetchData = async () => {
            await getAllTokenPayments();
        };
        fetchData();
    }, [filters]);

    const getAllTokenPayments = async () => {
        setIsFetching(true);
        const { minimumDatetime, maximumDatetime, transactionType, listingId } = filters;
        const data = {
            fromDate: minimumDatetime,
            toDate: maximumDatetime,
            listingId: listingId,
            refundStatus: transactionType
        }
        const result = await RefundPaymentsServices.getAllTokenPayments(data);
        // console.log("result", result)
        if (result && result.status === 200) {
            await setTokenPayments(result.data.data)
            await setIsFetching(false);
        } else {
            store.addNotification({
                title: "Error!",
                message: `${result.response.data.message || 'Something went wrong!'} (${result.response.status})`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true,
                    showIcon: true,
                    pauseOnHover: true
                }
            });
            setIsFetching(false);
        }
    };

    /**
* method to handle page change for pagination
* @param {*} page
*/
    // const onPageChange = async (page) => {
    //     const { limit } = this.state;
    //     const offset = (limit * (page - 1));
    //     await this.setState({ page, offset });
    //     await this.getAllTokenPayments();
    // };

    /**
   * Method to reset Pagination
   */
    // const resetPage = async () => {
    //     await this.setState({
    //         page: 1,
    //         offset: 0,
    //         //limit: 10,
    //     })
    // }

    const handleFilterChildData = async (childData) => {
        if (childData) {
            setFilters({
                listingId: childData.listingId,
                minimumDatetime: childData.minimumDatetime,
                maximumDatetime: childData.maximumDatetime,
                transactionType: childData.transactionType,
            });
        }
    };

    const handleInitiateRefundButtonClick = async (payment = null) => {
        if (payment) {
            setPaymentData(payment);
            setShowInitiateRefundModal(prev => !prev);
        }
    };

    const handleShowRefundDetails = async (OfflineListingId) => {
        const result = await RefundPaymentsServices.getTokenPaymentRefundHistory(OfflineListingId);
        if (result && result.status === 200) {
            setSelectedRefund(result.data.data)
            setShowRefundDetailsModal(prev => !prev)
            setIsFetching(false);
        }
    }

    return (
        <>
            {isFetching ? (
                <p>{constants.LOADING_DATA}</p>
            ) : (
                <Container fluid>
                    <Card>
                        <Card.Body>
                            <Portlet fluidHeight={true}>
                                <PortletHeader title={"Token Payments"} />
                                <PortletBody>
                                    <FilterComponent
                                        minimumDatetime={filters.minimumDatetime}
                                        maximumDatetime={filters.maximumDatetime}
                                        transactionType={filters.transactionType}
                                        listingId={filters.listingId}
                                        filterParentCallback={handleFilterChildData}
                                    />
                                    <Card>
                                        {tokenPayments && tokenPayments.length === 0 && <p>{constants.ZERO_DATA}</p>}
                                        {tokenPayments && tokenPayments.length > 0 &&
                                            <Card.Header>
                                                <Row className="align-items-center gx-2">
                                                    <Col xs={2}><strong>Property</strong></Col>
                                                    <Col xs={1}><strong>Listing Id</strong></Col>
                                                    <Col xs={2}><strong>Customer</strong></Col>
                                                    <Col xs={1}><strong>Amount</strong></Col>
                                                    <Col xs={2}><strong>Processing Fee</strong></Col>
                                                    <Col xs={2}><strong>Date & OrderId</strong></Col>
                                                    <Col xs={2}><strong>Refund</strong></Col>
                                                </Row>
                                            </Card.Header>}
                                        <Card.Body className="p-0">
                                            {tokenPayments && tokenPayments.map(payment => (
                                                <React.Fragment key={"idx" + payment.ListingId}>
                                                    <Row className="azuro-table-row align-items-center px-3 py-2 gx-2">
                                                        <Col xs={2}>
                                                            {payment.PropertyName || "-"}
                                                        </Col>
                                                        <Col xs={1}>
                                                            {payment.ListingId || "-"}
                                                        </Col>
                                                        <Col xs={2}>
                                                            {payment.TenantName || "-"}
                                                        </Col>
                                                        <Col xs={1}>
                                                            {formatAmount(payment.TokenAmount)}
                                                        </Col>
                                                        <Col xs={2}>
                                                            {formatAmount(payment.ProcessingFee)}
                                                        </Col>
                                                        <Col xs={2}>
                                                            <div>
                                                                {formatDateTime(payment.TokenPaymentDate)}<br />
                                                                <small className="text-muted">{payment.OrderId}</small>
                                                            </div>
                                                        </Col>
                                                        <Col xs={2}>
                                                            {(props.userDetails.userRoleCodes.includes('PROPERTY_MANAGEMENT_HEAD') &&
                                                                allowedUserEmails.includes(props.userDetails.email) && payment?.RefundStatus === "NOT INITIATED" &&
                                                                payment?.ProcessingFee > 0) && (
                                                                    <Button variant="link" size="sm" onClick={() => handleInitiateRefundButtonClick(payment)}>
                                                                        Initiate Refund
                                                                    </Button>
                                                                )}
                                                            {(props.userDetails.userRoleCodes.includes('PROPERTY_MANAGEMENT_HEAD') &&
                                                                allowedUserEmails.includes(props.userDetails.email)) && (payment?.RefundStatus !== "NOT INITIATED") &&
                                                                <Button variant="link" size="sm" onClick={() => handleShowRefundDetails(payment.OfflineListingId)}>View</Button>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <hr className="my-1" />
                                                </React.Fragment>
                                            ))}
                                        </Card.Body>
                                    </Card>
                                    {/* Code for pagination */}
                                    {/* {showPagination && showPagination && <UltimatePagination
                                        currentPage={page}
                                        totalPages={total}
                                        onChange={this.onPageChange}
                                        boundaryPagesRange={0}
                                        hidePreviousAndNextPageLinks={true}
                                        hideFirstAndLastPageLinks={page !== 1 && page !== total ? false : true}
                                    />} */}
                                </PortletBody>
                            </Portlet>
                        </Card.Body>
                    </Card>
                </Container>
            )}

            <Modal backdrop="static" keyboard={false} show={showInitiateRefundModal} onHide={() => setShowInitiateRefundModal(prev => !prev)}>
                <Modal.Header closeButton>
                    <Modal.Title>Initiate Refund</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={{
                            amount: (paymentData && paymentData.ProcessingFee) || 0,
                            orderId: (paymentData && paymentData.OrderId) || undefined,
                            refundNote: null
                        }}

                        validate={(values) => {
                            const errors = {};
                            const maxAmount = paymentData?.ProcessingFee;

                            if (!values.amount && values.amount !== 0) {
                                errors.amount = "Refund amount is required";
                            } else if (isNaN(values.amount)) {
                                errors.amount = "Refund amount must be a valid number";
                            } else if (parseFloat(values.amount) <= 0) {
                                errors.amount = "Refund amount must be greater than 0";
                            } else if (parseFloat(values.amount) > maxAmount) {
                                errors.amount = `Refund amount cannot exceed ₹${maxAmount?.toFixed(2)}`;
                            }

                            // Optional orderId / refundNote checks can be added here

                            return errors;
                        }}
                        // validationSchema={Yup.object().shape({
                        //     amount: Yup.number()
                        //         .min(2, "Amount must be at least 1")
                        //         .required("Refund amount is required"),
                        // })}
                        onSubmit={async (values, { setSubmitting }) => {
                            const data = {
                                amount: values.amount,
                                orderId: values.orderId,
                                refundNote: values.refundNote,
                                isTokenPayment: true,
                                OfflineListingId: paymentData.OfflineListingId
                            };
                            const result = await RefundPaymentsServices.createRefundToCustomer(data);
                            if (result.status === 200 || result.status === 201) {
                                store.addNotification({
                                    title: "Success!",
                                    message: `Refund Created Successfully!`,
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 5000,
                                        onScreen: true,
                                        showIcon: true,
                                        pauseOnHover: true
                                    }
                                });
                                await getAllTokenPayments();
                                setShowInitiateRefundModal(false);
                            }
                        }}
                    >
                        {({
                            values,
                            errors,
                            touched,
                            handleChange,
                            handleBlur,
                            handleSubmit,
                            setFieldValue,
                            isSubmitting,
                        }) => (
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col xs={12}>
                                        <Form.Group controlId="Property">
                                            <Form.Label>Property</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="Property"
                                                value={paymentData && paymentData?.PropertyName}
                                                disabled
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12}>
                                        <Form.Group controlId="CustomerName">
                                            <Form.Label>Customer Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="customerName"
                                                value={paymentData && paymentData?.TenantName}
                                                disabled
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12}>
                                        <Form.Group controlId="refundOrderId">
                                            <Form.Label>OrderId</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="refundOrderId"
                                                value={values.orderId}
                                                disabled
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            {/* {paymentData && errors.paymentData.orderId && touched.paymentData.orderId && (
                                                    <Form.Text className="text-danger">
                                                        {errors.paymentData.orderId}
                                                    </Form.Text>
                                                )} */}
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12}>
                                        <Form.Group controlId="refundAmount">
                                            <Form.Label>
                                                Refund Amount <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="refundAmount"
                                                value={values.amount !== undefined && values.amount !== null ? values.amount : ""}
                                                max={paymentData.ProcessingFee.toFixed(2)}
                                                required
                                                onChange={(e) => {
                                                    let inputValue = e.target.value;
                                                    if (inputValue === "") {
                                                        setFieldValue("amount", "");
                                                    } else if (!isNaN(inputValue)) {
                                                        setFieldValue("amount", inputValue);
                                                    }
                                                }}
                                                onBlur={(e) => {
                                                    let inputValue = e.target.value;
                                                    if (inputValue) {
                                                        const parsed = parseFloat(inputValue);
                                                        if (!isNaN(parsed)) {
                                                            setFieldValue("amount", parsed);
                                                        }
                                                    }
                                                }}
                                            />
                                            {errors.amount && touched.amount && (
                                                <Form.Text className="text-danger">
                                                    {errors.amount}
                                                </Form.Text>
                                            )}
                                            <Form.Text className="text-muted small">
                                                Refund amount cannot be greater than the {formatAmount(paymentData.ProcessingFee)}.
                                            </Form.Text>
                                        </Form.Group>

                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} className="text-right">
                                        <Button variant="secondary" className="mr-2" onClick={() => setShowInitiateRefundModal(prev => !prev)}>
                                            Cancel
                                        </Button>
                                        <Button type="submit" variant="primary" disabled={isSubmitting}>
                                            {isSubmitting ? "Processing..." : "Initiate Refund"}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>

            <Modal show={showRefundDetailsModal} onHide={() => setShowRefundDetailsModal(prev => !prev)}>
                <Modal.Header closeButton>
                    <Modal.Title>Refund Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedRefund && selectedRefund.length > 0 ? (
                        selectedRefund.map((refund, index) => (
                            <div key={refund.id || index}>
                                <p><strong>Refund ID:</strong> {refund.SqyRefundId}</p>
                                <p><strong>Amount:</strong> {formatAmount(refund.RefundAmount)}</p>
                                <p><strong>Date:</strong> {formatDateTime(refund.RefundDate)}</p>
                                <p><strong>Status:</strong> {refund.RefundStatus}</p>
                            </div>
                        ))
                    ) : (
                        <p>No refunds available.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowRefundDetailsModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );

};

const mapStateToProps = state => ({
    userDetails: state.auth && state.auth.user
});
export default withRouter(connect(
    mapStateToProps,
    null
)(RefundTokenPayments));